import NavItemIcon from "./navItemIcon";
import styles from "./sidebarItem.module.css"

type Props = {
    iconClass: string;
    text: string;
    onClick?: () => void;
    path?: string;
}

const SidebarItem = ({
    iconClass,
    text,
    onClick = () => {},
    path = "#",

} : Props) => {

    const pathName= window.location.pathname;

    const isActive = pathName === path;

    return (
        <li>
            <a
                href={path}
                className={`link-light rounded ${isActive && styles.active}`}
                onClick={onClick}
            >
                <NavItemIcon iconClass={iconClass} />
                {text}
            </a>
        </li>
    )
}

export default SidebarItem;